module.exports = __webpack_public_path__ + "img/8.6cd3435f.png";